import axios from 'axios';

const caseLawService = {
  /**
   * 获取所有以案释法数据
   * @returns {Promise} 返回以案释法数据列表
   */
  getAllCaseLaws() {
    return axios.get('/api/case-law', {
      timeout: 5000
    });
  },

  /**
   * 获取单个以案释法详情
   * @param {number} id - 案例ID
   * @returns {Promise} 返回以案释法详情
   */
  getCaseLawById(id) {
    return axios.get(`/api/case-law/${id}`, {
      timeout: 5000
    });
  },

  /**
   * 按分类获取以案释法
   * @param {string} category - 案例分类
   * @returns {Promise} 返回分类下的以案释法列表
   */
  getCaseLawsByCategory(category) {
    return axios.get(`/api/case-law/category/${category}`, {
      timeout: 5000
    });
  },

  /**
   * 搜索以案释法
   * @param {string} keyword - 搜索关键词
   * @returns {Promise} 返回搜索结果
   */
  searchCaseLaws(keyword) {
    return axios.get('/api/case-law/search', {
      params: { keyword },
      timeout: 5000
    });
  }
};

export default caseLawService; 